<template>
    <Head title="Troca de Senha" />
    <AuthenticatedLayout>
        <Heading title="Troca de Senha" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <article class="component-background-desktop component-background-mobile pt-10 pb-14 px-4 xl:px-[16vw] min-h-[80vh]">
            <div class="sm:px-5 xl:max-w-[350px] xl:min-w-[350px] text-primary">
                <h2 class="text-3xl text-primary font-semibold text-left xl:py-6 sm:py-4">Atualize sua senha</h2>
                <p class="text-md pb-4">
                    Por segurança, você precisa <strong>criar uma nova senha</strong>
                    para continuar. Ela precisa ter:
                </p>

                <ul>
                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasTenChar ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Mínimo de 10 caracteres</p>
                    </li>
                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasUpperCase ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um caractere maiúsculo</p>
                    </li>
                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasLowerCase ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um caractere minúsculo</p>
                    </li>
                    <li class="flex items-center pb-1">
                        <Icon name="Sucesso" :class="hasNumber ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um número</p>
                    </li>
                    <li class="flex items-center">
                        <Icon name="Sucesso" :class="hasSpecialChar ? '!text-success' : '!text-gray-500'" />
                        <p class="ml-2.5 text-sm">Um caractere especial (ex.: !@#$%)</p>
                    </li>
                </ul>

                <form @submit.prevent="submit" class="mb-4">
                    <ul class="pt-6">
                        <li class="mb-4">
                            <label class="mb-1 mr-5 flex font-bold">Nova senha</label>
                            <Input
                                placeholder="*********"
                                :state="inputState"
                                id="password"
                                v-model="form.password"
                                type="password"
                                required
                                autofocus
                                class="text-black"
                            />
                            <p class="text-[10px]">
                                Força da senha:
                                <span :class="powerPassword.classes">{{ powerPassword.text }}</span>
                            </p>
                        </li>

                        <li class="mb-8">
                            <label class="mb-1 mr-5 flex font-bold">Confirme sua senha</label>
                            <Input
                                placeholder="*********"
                                id="confirmPassword"
                                :state="isEqualInputState"
                                v-model="confirmPassword"
                                type="password"
                                required
                                class="text-black"
                            />
                            <p v-if="confirmPassword && !isEqual" class="text-[10px] text-error">
                                Senhas não coincidem
                            </p>
                        </li>

                        <li>
                            <Button @click.prevent="submit()" :enabled="allIsValid && isEqual ? true : false">
                                Alterar Senha
                            </Button>
                            <p v-if="$page.props.flash.error" class="text-[12px] text-error mt-2">
                                <strong>{{ $page.props.flash.error }}</strong>
                            </p>
                        </li>
                    </ul>
                </form>
            </div>
        </article>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Input from "@/Components/UI/Form/Input.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from '@/Components/UI/Texts/Heading.vue';
import Button from '@/Components/Button.vue';
import Icon from '@/Components/UI/Icons/Icon.vue';

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Input,
        Button,
        Icon,
    },
    data() {
        return {
            confirmPassword: '',
            form: this.$inertia.form({
                password: ''
            }),
        };
    },
    methods: {
        submit() {
            if (this.allIsValid && this.isEqual) {
                this.form.post('/password/forced');
            }
        },
    },
    computed: {
        hasTenChar() {
            return this.form.password.length > 9;
        },
        hasUpperCase() {
            return /([A-Z])/g.test(this.form.password);
        },
        hasLowerCase() {
            return /([a-z])/g.test(this.form.password);
        },
        hasNumber() {
            return /([0-9])/g.test(this.form.password);
        },
        hasSpecialChar() {
            return /[^A-Za-z0-9]/.test(this.form.password);
        },
        isEqual() {
            return this.form.password === this.confirmPassword;
        },
        allIsValid() {
            return (
                this.hasTenChar &&
                this.hasUpperCase &&
                this.hasLowerCase &&
                this.hasNumber &&
                this.hasSpecialChar
            );
        },
        inputState() {
            if (this.form.password) {
                return this.allIsValid ? 'success' : 'error';
            }
            return '';
        },
        isEqualInputState() {
            if (this.confirmPassword) {
                return this.isEqual ? 'success' : 'error';
            }
            return '';
        },
        powerPassword() {
            if (this.allIsValid) {
                return { classes: 'text-success', text: 'forte' };
            } else if (this.hasTenChar) {
                return { classes: 'text-yellow', text: 'média' };
            }
            return { classes: 'text-error', text: 'fraca' };
        },
    },
};
</script>
